import z from 'zod';

export const newsletterSignupValidationSchema = z
	.object({
		email: z.string().nonempty().max(512).email(),
		audienceType: z.union([z.literal(''), z.enum(['parent', 'professional'])]),
		parentInterest: z.string().optional(),
		professionalType: z.string().optional(),
	})
	.superRefine((values, ctx) => {
		if (!values.audienceType) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['audienceType'],
				message: 'Required',
			});
			return;
		}

		if (values.audienceType === 'parent') {
			if (!values.parentInterest) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['parentInterest'],
					message: 'Required',
				});
			}
		}

		if (values.audienceType === 'professional') {
			if (!values.professionalType) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['professionalType'],
					message: 'Required',
				});
			}
		}
	});
